import React from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Breadcrumbs.css";

const Breadcrumbs = () => {
  const { category, subCategory, brand, product } = useParams();

  const { categories = [] } = useSelector((state) => state.categoriesState);
  const { brands = [] } = useSelector((state) => state.brandsState);
  const { products = [] } = useSelector((state) => state.productsState);

  const paths = [
    { label: "Home", href: "/" },
    { label: "Shop", href: "/shop" },
  ];

  // Resolve brand name
  const brandObj = brand ? brands.find((b) => b.slug === brand) : null;
  const brandName = brandObj?.name || brand;

  // Resolve category & subcategory names
  const categoryObj = category ? categories.find((c) => c.slug === category) : null;
  const categoryName = categoryObj?.name || category;
  const subCategoryObj = subCategory ? categoryObj?.subcategories?.find((s) => s.slug === subCategory) : null;
  const subCategoryName = subCategoryObj?.name || subCategory;

  // Resolve product name
  const productObj = product ? products.find((p) => p.slug === product) : null;
  const productName = productObj?.name || product;

  // Build breadcrumb paths dynamically
  if (brandName) paths.push({ label: brandName, href: `/brand/${brand}` });
  if (categoryName)
    paths.push({
      label: categoryName,
      href: brandName ? `/brand/${brand}/${category}` : `/${category}`,
    });
  if (subCategoryName)
    paths.push({
      label: subCategoryName,
      href: brandName ? `/brand/${brand}/${category}/${subCategory}` : `/${category}/${subCategory}`,
    });
  if (productName)
    paths.push({
      label: productName,
      href: brandName
        ? `/brand/${brand}/${category}/${subCategory}/${product}`
        : `/${category}/${subCategory}/${product}`,
    });

  return (
    <>
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        {paths.map((p, idx) => (
          <span key={idx}>
            {idx < paths.length - 1 ? (
              <>
                <Link to={p.href}>{p.label}</Link>
                <span className="separator">›</span>
              </>
            ) : (
              <span className="current">{p.label}</span>
            )}
          </span>
        ))}
      </nav>

      {/* JSON-LD Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: paths.map((p, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: p.label,
            item: `https://spabrands.me${p.href}`,
          })),
        })}
      </script>
    </>
  );
};

export default Breadcrumbs;
